import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICancelamentoServicoEntradaPreview,
  ICancelServicoEntrada,
  ICreateServicoEntrada,
  IGetServicoEntradaByServicoEntradaCavaloBody,
  IGetServicoEntradaPrecoByEntrada,
  IGetServicosEntradaByCavalo,
  IGetServicosEntradaByGateEntrada,
  IGetServicosParams,
  IPatchServicoEntradaEmpresaFaturada,
  IUpdateServicoEntrada
} from './servicoEntrada.model';

@Injectable({
  providedIn: 'root'
})
export class ServicoEntradaService {
  constructor(private http: HttpClient) {}

  public CreateServico(body: ICreateServicoEntrada, guid: string): Observable<any> {
    const headers = new HttpHeaders({
          IdempotencyKey: guid
        });
        
    const url = `${environment.baseURL}ServicoEntrada/CreateServicoEntrada`;

    return this.http.post<any>(url, body, { headers: headers });
  }

  public UpdateServico(
    id: number,
    body: IUpdateServicoEntrada
  ): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/UpdateServicoEntrada?id=${id}`;

    return this.http.put<any>(url, body);
  }

  public GetServicos(body?: IGetServicosParams): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/GetServicosEntradaPaginated`;
    let params: any = {};

    if (body?.FK_SRVC) params.FK_SRVC = body.FK_SRVC;

    if (body?.FK_SRVC_ENTR) params.FK_SRVC_ENTR = body.FK_SRVC_ENTR;

    if (body?.FK_EPSA) params.FK_EPSA = body.FK_EPSA;

    if (body?.FK_GATE_ENTR) params.FK_GATE_ENTR = body.FK_GATE_ENTR;

    if (body?.TX_PLCA_CAVA) params.TX_PLCA_CAVA = body.TX_PLCA_CAVA;

    if (body?.NM_MTRT) params.NM_MTRT = body.NM_MTRT;

    if (body?.DT_SRVC_ENTR_INIC)
      params.DT_SRVC_ENTR_INIC = body.DT_SRVC_ENTR_INIC;

    if (body?.DT_SRVC_ENTR_FIM) params.DT_SRVC_ENTR_FIM = body.DT_SRVC_ENTR_FIM;

    if (body?.FL_CNCL) params.FL_CNCL = true;

    if (body?.PAGE_NUMBER) params.PAGE_NUMBER = body.PAGE_NUMBER;

    if (body?.PAGE_SIZE) params.PAGE_SIZE = body.PAGE_SIZE;

    return this.http.get<any>(url, { params });
  }

  public GetServicoById(id?: number): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/GetServicoEntradaById`;
    let params: any = {};

    if (id) {
      params.id = id;
    }

    return this.http.get<any>(url, { params });
  }

  public GetServicoByPreco(
    PK_GATE_ENTR?: number
  ): Observable<IGetServicoEntradaPrecoByEntrada> {
    const url = `
      ${environment.baseURL}ServicoEntrada/GetServicoEntradaPrecoByEntrada?PK_GATE_ENTR=${PK_GATE_ENTR}
    `;

    return this.http.get<IGetServicoEntradaPrecoByEntrada>(url);
  }

  public GetServicosEntradaByCavalo(body: IGetServicosEntradaByCavalo) {
    const url = `${environment.baseURL}ServicoEntrada/GetServicosEntradaByCavalo`;
    let params: any = {};

    if (body.TX_PLCA_CAVA) {
      params.TX_PLCA_CAVA = body.TX_PLCA_CAVA;
    }

    return this.http.get<any>(url, { params });
  }

  public GetServicosEntradaByGateEntrada(
    body: IGetServicosEntradaByGateEntrada
  ) {
    const url = `${environment.baseURL}ServicoEntrada/GetServicosEntradaByGateEntrada`;
    let params: any = {};

    params.PK_GATE_ENTR = body.PK_GATE_ENTR;

    return this.http.get<any>(url, { params });
  }

  public GetServicoEntradaByServicoEntradaAndCavalo(
    body?: IGetServicoEntradaByServicoEntradaCavaloBody
  ) {
    const url = `${environment.baseURL}ServicoEntrada/GetServicoEntradaByServicoEntradaAndCavalo`;
    let params: any = {};

    if (body?.PK_SRVC) {
      params.PK_SRVC = body.PK_SRVC;
    }
    if (body?.PK_SRVC_ENTR) {
      params.PK_SRVC_ENTR = body.PK_SRVC_ENTR;
    }
    if (body?.PK_AGND) {
      params.PK_AGND = body.PK_AGND;
    }

    if (body?.TX_PLCA_CAVA) {
      params.TX_PLCA_CAVA = body.TX_PLCA_CAVA;
    }

    return this.http.get<any>(url, { params });
  }

  public GetReceiptServicoEntradaById(
    id: number,
    tipoDocumento: number,
    pkSrvcEntr?: number,
    isHigienizacaoRecibo: boolean = false
  ): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/GetReceiptServicoEntradaById`;
    const params: any = {};

    if (pkSrvcEntr) {
      params.PK_SRVC_ENTR = pkSrvcEntr;
    } else {
      params.PK_GATE_ENTR = id;
    }
    
    params.FL_TIPO_DOCU = tipoDocumento;
    params.IsHigienizacaoRecibo = isHigienizacaoRecibo;

    return this.http.get<any>(url, { params });
  }

  public PatchServicoEntradaEmpresaFaturada(
    body: IPatchServicoEntradaEmpresaFaturada
  ): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/PatchServicoEntradaEmpresaFaturada`;

    return this.http.patch<any>(url, body);
  }

  public GetCancelamentoServicoEntradaPreview(
    id: number
  ): Observable<ICancelamentoServicoEntradaPreview> {
    const url = `${environment.baseURL}ServicoEntrada/GetCancelamentoServicoEntradaPreview`;

    return this.http.get<ICancelamentoServicoEntradaPreview>(url, {
      params: { id }
    });
  }

  public CancelServicoEntrada(
    id: number,
    body: ICancelServicoEntrada
  ): Observable<any> {
    const url = `${environment.baseURL}ServicoEntrada/CancelServicoEntrada?id=${id}`;

    return this.http.put<any>(url, body);
  }
}
